import * as React from 'react'
import { Descriptions } from 'antd'
import { Well } from '@pushly/aqe/lib/components'
import JsonView from '@halo/components/json-view/json-view'

export interface ICatalogExtractionResult {
    item_type: string
    item_id: string
    language: string
    extracted_fields: Record<string, any>
}

interface IProps {
    results: ICatalogExtractionResult[]
}

/**
 * Renders one Well per catalog extraction result (most pages produce a single
 * result, but multi-schema pages can produce several). Each Well shows the
 * top-level identity fields followed by the full extracted_fields JSON.
 */
function CatalogExtractionResultsPanel(props: IProps) {
    return (
        <>
            {props.results.map((result, idx) => (
                <Well
                    key={idx}
                    title={
                        props.results.length > 1
                            ? `Catalog Extraction Results (${idx + 1})`
                            : 'Catalog Extraction Results'
                    }
                    footerMode="hidden"
                >
                    <Descriptions layout="horizontal" column={1} colon={false}>
                        <Descriptions.Item label="item_type">{result.item_type}</Descriptions.Item>
                        <Descriptions.Item label="item_id">{result.item_id}</Descriptions.Item>
                        <Descriptions.Item label="language">{result.language}</Descriptions.Item>
                        <Descriptions.Item label="extracted_fields">
                            <JsonView data={result.extracted_fields} defaultExpanded={true} />
                        </Descriptions.Item>
                    </Descriptions>
                </Well>
            ))}
        </>
    )
}

export default CatalogExtractionResultsPanel
